import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "I learned two things today 16.8.",
  "description": "",
  "published": "2011-08-17T00:00:00.000Z",
  "redirect_from": ["/blog/i-learned-two-things-today-16-8-2/swizec/2219"],
  "categories": "Airbnb, Brian Chesky, Learning, Personal, San Francisco, Startup School, Y Combinator",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/08/5089475323_3dd9dbf197_m1.jpg",
        "alt": "Brian Chesky, CEO of Airbnb, speaks to Startup...",
        "title": "Brian Chesky, CEO of Airbnb, speaks to Startup..."
      }}></img></p>
    <p>{`Today I learned that yesterday there was some confusion about the dates of when I learned the two things because I was writing just past midnight. Well, ok, I just learned that right this very instance. This is the real 16.8. post, the other one is actually 15.8. and I don't want to go gallivanting around and changing titles all willy nilly. That's just not kosher.`}</p>
    <p>{`The actually important thing that I learned today has to do with `}<a parentName="p" {...{
        "href": "http://www.airbnb.com/",
        "title": "Airbnb"
      }}>{`Airbnb`}</a>{` and my visit of a `}<a parentName="p" {...{
        "href": "http://www.ycombinator.com",
        "title": "Y Combinator"
      }}>{`YC`}</a>{` dinner as a guest. Was a pretty fun experience and I really got the feeling that `}<a parentName="p" {...{
        "href": "http://www.crunchbase.com/person/brian-chesky",
        "title": "Brian Chesky"
      }}>{`Brian Chesky`}</a>{` is a much cooler guy than I originally thought ... especially from having seen him at `}<a parentName="p" {...{
        "href": "http://startupschool.org/",
        "title": "Startup School"
      }}>{`Startup School`}</a>{` yesteryear.`}</p>
    <p>{`Now I'm not sure this is the general experience people get from these dinners, but it seems that the off-the-record and encouragement from Graham to really speak their mind brings the best out in people. Or it might just be that when people talk to others who are supposedly like-minded and the whole situation is less formal, people tend to be more ... human?`}</p>
    <p>{`Oh and apparently Macs have some sort of safe boot mode. It's really quite annoying when you want to have a broken keyboard connected because otherwise the power button doesn't work.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blogs.wsj.com/venturecapital/2011/07/25/airbnb-from-y-combinator-to-112m-funding-in-three-years/"
        }}>{`Airbnb: From Y Combinator To `}{`\\`}{`\\`}{`\\`}{`\\$112M Funding In Three Years`}</a>{` (blogs.wsj.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://techcrunch.com/2011/08/11/y-combinators-7th-annual-startup-school-set-for-october/"
        }}>{`Y Combinator's 7th Annual Startup School Set For October`}</a>{` (techcrunch.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=25f728f9-6896-47bb-b271-1c626fb205b3",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      